export const props = {
  afterLogin: {
    type: String,
    default: ''
  }
}
